var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"detail-journeys"},[(!_vm.journeyId)?_c('simple-journey',{attrs:{"is-summary":_vm.isSummary,"journeyData":_vm.journeyData}}):_c('journey-overview',{attrs:{"journeyId":_vm.journeyId}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bef5fb6","hasScoped":false,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./libs/components/detail/tabView/Journey.vue
// module id = 615
// module chunks = 0 3